<script>
    import categories from "../stores/categories";
    import {categoriesLoad} from "../lib/requests";
    import CategoryItem from "./CategoryItem.svelte";
    import {collapseAll, findNode} from "../lib/lib";
    import CategoryEdit from "./CategoryEdit.svelte";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';

    let loading = false;
    let selectedParentPath = '';
    let searchTerm = '';
    let oldTerm = '';
    let searchResults = [];
    let searchIndex = null;

    let newCategoryParentId = null;

    const load = async () => {
        loading = true;

        const [err, res] = await categoriesLoad();

        if (err) {
            alert('error ' + err)
            return;
        }

        $categories.tree = res.tree;
        loading = false;
    }

    const anOtherIsEdited = () => {
        if ($categories.edit_id !== null) {
            app_alert.show('error', "Έχετε ήδη ανοιχτή μια κατηγορία για επεξεργασία");
            return true;
        }
        return false;
    }

    const noneSelected = () => {
        if ($categories.selected_id === 0) {
            app_alert.show('error', "Δεν έχετε επιλέξει κατηγορία!");
            return true;
        }
        return false;
    }

    const onCollapseAll = () => {
        collapseAll($categories.tree, $categories.selected_id);
        $categories.tree = $categories.tree;
        scrollToElement('cat-item-' + $categories.selected_id);
    }

    const onEdit = () => {
        if (anOtherIsEdited()) {
            return;
        }
        if (noneSelected()) {
            return;
        }

        $categories.edit_id = $categories.selected_id;
    }

    const onSearch = (event) => {
        if (event.key === 'Enter') {
            if (oldTerm !== searchTerm) {
                resetSearch();
                if (searchTerm.length > 0) {

                    if (!isNaN(searchTerm)) {
                        // if search term is a location id
                        searchResults = [];
                        let node = findNode(searchTerm, $categories.tree);
                        if (node) {
                            searchResults.push(node.id);
                        }
                    } else {
                        // if search term is a string
                        let tree = $categories.tree;
                        if (onRegionSearch && $categories.selected_id > 0) {
                            // get node parent region
                            let region = findNodeParentOfLevel($categories.selected_id, 0, tree);
                            if (region) {
                                tree = region.children;
                            }
                        }

                        // put "Άνω" and "Κάτω" first
                        searchTerm = searchTerm.trim();
                        let arr = searchTerm.split(" ");
                        if (arr.length) {
                            let lastWord = arr[arr.length - 1];
                            if (lastWord === "Επάνω" || lastWord === "Άνω" || lastWord === "Κάτω") {
                                arr.unshift(lastWord);
                                arr.pop();
                                searchTerm = arr.join(' ');
                            }
                        }

                        searchResults = searchNodes(upCaseStr(searchTerm), tree);
                    }

                    oldTerm = searchTerm;
                    if (searchResults.length === 0) {
                        error.show("Δεν βρέθηκαν αποτελέσματα");
                    } else {
                        $categories.last_selected_id = $categories.selected_id;
                    }
                }
            }
            showNextSearchResult();
        } else if (event.key === 'Escape') {
            searchTerm = '';
            resetSearch();
        }
    }

    const resetSearch = () => {
        oldTerm = '';
        searchResults = [];
        searchIndex = null;
        $categories.marked_id = 0;
    }

    const showNextSearchResult = () => {
        if (searchResults.length > 0) {
            if (searchIndex === null) {
                searchIndex = 0;
            } else {
                searchIndex++;
                if (searchIndex > searchResults.length - 1) {
                    searchIndex = 0;
                }
            }

            $categories.marked_id = searchResults[searchIndex];
            gotoLocation(searchResults[searchIndex], false);
        }
    }

    const onGotoLastSelected = () => {
        $categories.selected_id = $categories.last_selected_id;
        scrollToElement('cat-item-' + $categories.selected_id);
    }

    const addCategory = () => {
        if (anOtherIsEdited()) {
            return;
        }
        if (noneSelected()) {
            return;
        }

        newCategoryParentId = $categories.selected_id;
    }

    const updateTree = (data) => {

        if (data) {
            let parent = findNode(data.parent_id, $categories.tree);
            if (parent) {
                parent.children = [...parent.children, data];
            }
            $categories.tree = $categories.tree;
        }

        newCategoryParentId = null;
    }

    load();
</script>

<div class="section-header">
    <div class="row">
        <div class="col-md-8">
            <button class="btn btn-primary" title="Επεξεργασία επιλεγμένης" on:click={addCategory}><i
                    class="fa fa-plus"></i></button>
            <button class="btn btn-primary" title="Επεξεργασία επιλεγμένης" on:click={onEdit}><i
                    class="fa fa-edit"></i></button>
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ onCollapseAll }" title="Κατάρρευση όλων"><i
                    class="fa fa-toggle-up"></i></button>
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ load }" title="Ανανέωση κατηγοριών"><i
                    class="fa fa-refresh"></i></button>
        </div>
        <div class="col-md-4">
            <div class="form-inline text-right">
                <input type="text" class="form-control" bind:value={searchTerm} on:keyup="{ onSearch }"
                       placeholder="αναζήτηση">
                <button class="btn btn-primary" title="επιστροφή στην αρχική επιλογή" on:click="{ onGotoLastSelected }">
                    <i class="fa fa-arrow-left"></i></button>
            </div>
        </div>
    </div>
</div>

<div class="panel">
    <div class="panel-heading">
        <h2>Κατηγορίες</h2>
        <h6>{ selectedParentPath }</h6>
    </div>
    <div class="panel-body fixed-height">
        <div class="panel-body-inner">
            {#each $categories.tree as category}
                <CategoryItem category="{category}" on:edit="{ onEdit }"/>
            {/each}
        </div>
    </div>
</div>

{#if newCategoryParentId != null}
    <CategoryEdit parent_id={newCategoryParentId} closeCallback={updateTree}/>
{/if}